import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import { Heading } from '@shieldpay/bumblebee/heading';
import { Layout } from '@shieldpay/bumblebee/layout';
import { Text } from '@shieldpay/bumblebee/text';

const ErrorHeading = ({ children }: { children: ReactNode }) => (
  <Heading align="left">{children}</Heading>
);

const Error = ({ children }: { children: ReactNode }) => (
  <Layout alignContent={{ x: 'left', y: 'center' }} spacing="basePos3">
    {children}
  </Layout>
);

Error.Heading = ErrorHeading;

const ErrorDescription = ({ id }: { id: string }) => (
  <FormattedMessage
    id={id}
    values={{
      p: (values: Array<ReactNode>) => (
        <Text paragraph align="left">
          {values}
        </Text>
      ),
    }}
  />
);

Error.Description = ErrorDescription;

export { Error };
